<template>
  <div v-if="isDispatchAddress || hasNetwork" class="vz-personal-order-blocks pdf-order-section">
    <div>
      <vz-special-requirement
        v-if="isDispatchAddress"
        :order-lock="orderLockDispatch"
        title-card="Забор груза"
        class="w-100"
      />
    </div>
    <div>
      <div v-if="hasNetwork" class="text-h1 mb-20">
        <span style="flex-shrink: 0">Отвоз груза</span>
      </div>
      <div v-if="hasRequirements" class="vz-network-order-specific-loading">
        <p class="vz-network-order-special-requirements-title">Требования при доставке</p>
        <div v-for="value of orderStore.networkingAddress.specificLoading">
          <vz-icon name="check" class="mr-5" size="16" />
          <span>{{ value }}</span>
        </div>
      </div>
      <div
        v-if="orderStore.networkingAddress?.cargoDescription"
        class="text-caption vz-border-card network-warehousing-card color-info2 mb-10"
      >
        <span v-html="orderStore.networkingAddress?.cargoDescription" />
      </div>
      <div v-if="hasCargoChecker" class="vz-special-requirement-card-list">
        <vz-checkbox
          v-model="checkCargoBeforeShipping"
          :disabled="orderLockDestination"
        >
          <template #label>
            <span class="vz-checkbox-label">Проверка груза при отправке</span>
            <vz-tooltip-info :text="cargoCheckerText" class="ml-5" />
          </template>
        </vz-checkbox>
      </div>
      <div v-if="needLoadingText" class="mb-15 vz-network-order-specific-loading">
        <p class="vz-network-order-special-requirements-title">Рекомендации при доставке</p>
        <div :class="{'text-decoration-through': !needLoadingExact}">
          <vz-icon name="check" class="mr-5" size="16" />
          <span>{{ needLoadingText }}</span>
        </div>
      </div>
      <div>
        <p class="vz-network-order-special-requirements-title">Дополнительные услуги</p>
        <vz-button
          v-if="hasNetwork && !more"
          variant="primary"
          class="mt-10"
          @click="more = true"
        >Подробнее</vz-button>
        <vz-special-requirement
          v-if="more"
          :order-lock="orderLockDispatch"
          direction-to
          class="w-100"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {useOrderStore} from '@/stores/order';
import VzSpecialRequirement from '@/components/personal/order/special-requirements/vz-special-requirement.vue';
import VzCheckbox from '~/components/ui-kit/vz-checkbox.vue';
import VzIcon from '~/components/ui-kit/vz-icon.vue';
import VzTooltipInfo from '~/components/ui-kit/vz-tooltip-info.vue';
import VzButton from '~/components/ui-kit/vz-button.vue';

const orderStore = useOrderStore()
const cargoCheckerText = 'Проверим ваш груз на соответствие требованиям сети перед осуществлением доставки. ' +
  'В случае выявления несоответствий, уведомим об этом и окажем дополнительные услуги по финальной подготовке груза к приёмке'

const isDispatchAddress = computed(() => {
  return orderStore.orderForm.directions.dispatch.direction === 'address'
})

const hasRequirements = computed(() => {
  return Object.keys(orderStore.networkingAddress?.specificLoading || {}).length > 0
})

const hasNetwork = computed(() => {
  return orderStore.orderForm.directions.destination.networkGuid
})

const hasCargoChecker = computed(() => {
  return Boolean(orderStore.orderForm?.directions?.destination?.hasCcbs && !orderStore.orderForm?.directions?.destination?.isCustom)
})

const orderLockDispatch = computed(() => {
  return Boolean(orderStore.orderForm?.meta?.lockState?.dispatch)
})

const orderLockDestination = computed(() => {
  return Boolean(orderStore.orderForm?.meta?.lockState?.destination)
})

const checkCargoBeforeShipping = computed({
  get() {
    return orderStore.orderForm.meta.checkCargoBeforeShipping
  },
  set(value: boolean) {
    orderStore.orderForm.meta.checkCargoBeforeShipping = value
    orderStore.getOrderPriceAction()
  }
})

const more = computed({
  get() {
    return !!orderStore.orderForm.meta.additionInfo
  },
  set(value: boolean) {
    orderStore.orderForm.meta.additionInfo = value
  }
})

const needLoadingText = computed(() => {
  if (!orderStore.networkingAddress?.needLoading) {
    return ''
  }
  let result = `Разгрузочные работы: ${orderStore.networkingAddress.needLoading.floor} этаж`
  if (orderStore.networkingAddress.needLoading.hasLift) {
    result += ', грузовой лифт'
  }
  return result
})

const needLoadingExact = computed(() => {
  if (!orderStore.networkingAddress?.needLoading) {
    return false
  }
  const unloadingOperations = orderStore.orderForm.specialRequirements.destination.unloadingOperations

  return unloadingOperations.active &&
    +unloadingOperations.floor === orderStore.networkingAddress.needLoading.floor &&
    unloadingOperations.freightElevator === orderStore.networkingAddress.needLoading.hasLift
})

watch(() => hasCargoChecker.value, () => {
  checkCargoBeforeShipping.value = hasCargoChecker.value
})
</script>

<style lang="scss" scoped>
.vz-network-order-special-requirements {
  h5 {
    font-size: 20px;
    font-weight: 500;
    margin-bottom: 20px;
    line-height: 23px;
  }
  &-title {
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 10px;
    line-height: 16px;
  }
}
.vz-network-order-specific-loading {
  > div {
    margin-bottom: 15px;
    display: flex;
    align-items: flex-start;

    span {
      line-height: 16px;
    }
  }
}
</style>
